import React from "react";
import pdfIcon from "assets/icons/pdfDownloadBtn.svg";
import gmailIcon from "assets/icons/emailIcon.svg";
import { LuArrowDownToLine, LuShare2 } from "react-icons/lu";
import { IoMdCopy } from "react-icons/io";
import ButtonOutline from "components/semantic/ButtonOutline";

type MsgType = "Healthy" | "Critical" | "Needs Attention";

interface Props {
  type: MsgType;
  onDownload: () => void;
  onCopy: () => void;
  onGmailShare: () => void;
}

const MotorPolicyAction: React.FC<Props> = ({ type, onDownload, onCopy, onGmailShare }) => {
  return (
    <div className={`flex flex-col md:flex-row items-center ${type === "Healthy" ? "mt-6" : "mt-6"} bg-[#F4F5FA] rounded-xl p-4 justify-center gap-4`}>
      {/* Info Section */}
      {/* {detailedKypPdfUrl && ( */}
      <div className="flex items-center gap-3 justify-center">
        <img src={pdfIcon} alt="PDF" />
        <p className="text-sm text-gray-800 font-bold">Download your Know Your Policy summary as a PDF for your records.</p>
      </div>
      {/* )} */}

      {/* Buttons Section */}
      <div className="flex gap-3 w-full flex-wrap custom-lg:flex-nowrap sm:w-auto justify-center">
        {/* {detailedKypPdfUrl && ( */}
        <div className="relative">
          <button className="border-[1.5px] flex items-center justify-center gap-2 h-12 rounded-full w-[180px] md:w-48 font-bold border-[#2F9D7F] text-[#2F9D7F] hover:bg-[#F1FCF9] px-4 py-2" onClick={onDownload}>
            <LuArrowDownToLine />
            <p>Download PDF</p>
          </button>
        </div>
        {/* )} */}

        {type !== "Healthy" && (
          <>
            <div className="relative ">
              <ButtonOutline title="Copy Mail Content" onClick={onCopy} icon={<IoMdCopy />} className="hidden xl:flex" />
            </div>
            <div className="relative">
              <ButtonOutline
                className="hidden xl:flex"
                title={
                  <p className="flex items-center gap-2 text-sm">
                    Share via{" "}
                    <span className="font-semibold flex items-center">
                      <img src={gmailIcon} alt="Gmail" />
                      <span>Gmail</span>
                    </span>
                  </p>
                }
                onClick={onGmailShare}
                icon={<LuShare2 />}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MotorPolicyAction;
